import { AxiosPromise, AxiosResponse } from 'axios'
import makeDate from '../utils/makeDate'
import request from '../utils/request'
import { IPoll } from './types'

export const getPoll = (uuid: string): AxiosPromise<IPoll> =>
    request({
        url: `/api/poll/${uuid}`,
        method: 'get',
    }).then((poll: AxiosResponse<IPoll>) => {
        makeDate(poll)
        return poll
    })
